import React from "react"
import CustomButton from "components/Atoms/CustomButton"
import CustomButtonGroup from "components/Atoms/CustomButtonGroup"

const ViewSwitch = ({ className, active, onClick }) => {
  return (
    <CustomButtonGroup joint className={className}>
      <CustomButton
        intent={active === "map" ? "primary" : "none"}
        icon="map"
        text="Map"
        onClick={() => onClick("map")}
      />
      <CustomButton
        intent={active === "list" ? "primary" : "none"}
        icon="list"
        text="List"
        onClick={() => onClick("list")}
      />
    </CustomButtonGroup>
  )
}

export default ViewSwitch
